import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Apps } from "@mui/icons-material";
import Moment from 'moment';

function WarehouseUpdateModal({ title, onClose, id, handleView, workplaceModalOption, originRows, MenuUpdateYN }) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [sectionRows, setSectionRows] = useState([]);
  const [updateSectionRows, setUpdateSectionRows] = useState([]);
  const [sectionColumns, setSectionColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    workplace_id: 0,
    warehouse_id:0,
    warehouse_name: '',
    warehouse_width: 0,
    warehouse_depth: 0,
    warehouse_height: 0,
    warehouse_memo: ''
  });
  const [updateFlag, setUpdateFlag] = useState(MenuUpdateYN === 'Y' && originRows.some(row =>
    [row.warehouse_reg_user_id, row.warehouse_update_user_id].includes(Number(localStorage.getItem('user_id')))
  ));

  const handleInitSelect = () => {
    setUpdateSectionRows([]);
    // 창고정보
    setInputs({
      workplace_id: originRows[0].workplace_id,
      warehouse_id: originRows[0].warehouse_id,
      warehouse_name: originRows[0].warehouse_name,
      warehouse_width: originRows[0].warehouse_width,
      warehouse_depth: originRows[0].warehouse_depth,
      warehouse_height: originRows[0].warehouse_height,
      warehouse_memo: originRows[0].warehouse_memo
    });

    // 창고 구역
    var sectionData = originRows.filter((item, index) => {
      return (
        originRows.findIndex((item2, index2) => {
          return typeof item.section_name !== 'undefined' && item.section_id === item2.section_id && item.section_name === item2.section_name && item.section_width === item2.section_width && item.section_depth === item2.section_depth && item.section_height === item2.section_height && item.section_memo === item2.section_memo;
        }) === index
      );
    });

    sectionData = sectionData.sort(function(a, b) { 
      return a.section_id < b.section_id ? -1 : a.section_id > b.section_id ? 1 : 0;
    });
    
    setSectionRows(sectionData.map((item, index) => ({
      id: item.section_id,
      section_id: item.section_id,
      section_name: item.section_name,
      section_width: item.section_width,
      section_depth: item.section_depth,
      section_height: item.section_height,
      section_memo: item.section_memo,
      row_type:'O',
      update_type: 'N'
    })));

  }

  const handleSetting = () => {
    setSectionColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {sectionDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {sectionAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {sectionDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'section_id', headerName: '구역ID', width: 0, headerAlign: 'center' },
      { field: 'section_name', headerName: '구역명', width: 200, headerAlign: 'center', editable: true },
      { field: 'section_width', headerName: '구역가로', width: 110, headerAlign: 'center', align: 'right', type: 'number', editable: true },
      { field: 'section_depth', headerName: '구역세로', width: 110, headerAlign: 'center', align: 'right', type: 'number', editable: true },
      { field: 'section_height', headerName: '구역높이', width: 110, headerAlign: 'center', align: 'right', type: 'number', editable: true },
      { field: 'section_memo', headerName: '비고', width: 300, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setSectionColumnVisibilityModel({
      id: false,
      actions: updateFlag,
      section_id: false,
      section_name: true,
      section_width: true,
      section_depth: true,
      section_height: true,
      section_memo: true,
      row_type: false,
      update_type: false
    });
  }

  const [sectionColumnVisibilityModel, setSectionColumnVisibilityModel] = useState({
    id: false,
    actions: updateFlag,
    section_id: false,
    section_name: true,
    section_width: true,
    section_depth: true,
    section_height: true,
    section_memo: true,
    row_type: false,
    update_type: false
  });
  
  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    handleSetting();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  useEffect(() => {
    handleInitSelect();
  }, [originRows]);
  
  useEffect(() => {
    // sectionRows가 변경될 때 마지막 Row ADD가 없으면 추가시킨다.
    let ADD_YN= 'Y'
    for(let i=0; i<sectionRows.length; i++){
      if(sectionRows[i].row_type === 'A' && sectionRows[i].update_type === 'N'){
        ADD_YN = "N"; //마지막 Row update_type = 'N'으로 N유지
      }
    }

    if(ADD_YN === 'Y' && updateFlag){
      setSectionRows((sectionRows) => [...sectionRows, { 
        id: Number(appStore.getMaxListID(sectionRows))+1,
        section_id: 0,
        section_name: '',
        section_width: '',
        section_depth: '',
        section_height: '',
        section_memo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [sectionRows]);

  const onSelectChange = (type, value) => {
    const nextInputs = {
        ...inputs,
        [type] : value
    };
    setInputs(nextInputs);
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processSectionRowUpdate = (newRow, oldRow) => {
    //거래처 주소 Rows Update
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
    const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우
    
    if(newRow.section_name !== oldRow.section_name || newRow.section_width !== oldRow.section_width || newRow.section_depth !== oldRow.section_depth || newRow.section_height !== oldRow.section_height || newRow.section_memo !== oldRow.section_memo){
      // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
      var row_section_id = 0;
      var row_section_name = '';
      var row_section_width = '';
      var row_section_depth = '';
      var row_section_height = '';
      var row_section_memo = '';
      if(String(newRow.row_type) === "A"){
        //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
        if((newRow.section_name).trim() !== '' || newRow.section_width !== '' || newRow.section_depth !== '' || newRow.section_height !== '' || (newRow.section_memo).trim() !== ''){
          row_section_id = newRow.section_id;
          row_section_name = (newRow.section_name).trim();
          row_section_width = newRow.section_width;
          row_section_depth = newRow.section_depth;
          row_section_height = newRow.section_height;
          row_section_memo = (newRow.section_memo).trim();
        }
      }else{
        // 추가 아닌 ROW는 originRows과 비교해야함.
        // console.log('추가 아닌 ROW는 originRows과 비교해야함.')
        sectionRows.map((data) => data.id === newRow.id 
          && ((data.section_name).trim() !== (newRow.section_name).trim() || data.section_width !== newRow.section_width || data.section_depth !== newRow.section_depth || data.section_height !== newRow.section_height || (data.section_memo).trim() !== (newRow.section_memo).trim())?
          (
            row_section_id = data.section_id,
            row_section_name = (data.section_name).trim(),
            row_section_width = data.section_width,
            row_section_depth = data.section_depth,
            row_section_height = data.section_height,
            row_section_memo = (data.section_memo).trim()
          ):""
        )
      }
      
      if((row_section_name).trim() === '' && row_section_width === '' && row_section_depth === '' && row_section_height === '' && (row_section_memo).trim() === ''){
        // 1. 값이 수정되지 않은 경우.
        if(updateSectionRows.length > 0){
          // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
          // console.log('[updateRows 원복] ' + updateRows.length);
          setUpdateSectionRows(updateSectionRows.filter((data) => data.id !== newRow.id));
          setSectionRows(sectionRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        // 2. 값이 수정된 경우.
        var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
        for (let i = 0; i < updateSectionRows.length; i++) {
          if(updateSectionRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateRows.length);
          setUpdateSectionRows(updateSectionRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setSectionRows(sectionRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateRows.length);
          setUpdateSectionRows(prevRows => [...prevRows, newUpdateDataArray]);
          setSectionRows(sectionRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };
  
  const sectionAddClick = (object) => {
    //창고 구역 추가 버튼
    setSectionRows((sectionRows) => [...sectionRows, { 
      id: Number(appStore.getMaxListID(sectionRows))+1,
      section_id: 0,
      section_name: '',
      section_width: '',
      section_depth: '',
      section_height: '',
      section_memo: '',
      row_type:'A',
      update_type: 'N'
    }]);
  };

  const sectionDeleteClick = (object) => {
    //창고 구역 삭제 버튼
    setUpdateSectionRows((updateSectionRows) => updateSectionRows.filter((data) => data.id !== object.row.id));
    if(object.row.row_type === 'O'){
      setUpdateSectionRows(prevRows => [...prevRows, {
        id: object.row.id,
        section_id: object.row.section_id,
        section_name: (object.row.section_name).trim(),
        section_width: object.row.section_width,
        section_depth: object.row.section_depth,
        section_height: object.row.section_height,
        section_memo: (object.row.section_memo).trim(),
        row_type:'O',
        update_type: 'D'
      }]);
    }
    setSectionRows((sectionRows) => sectionRows.filter((data) => data.id !== object.row.id));
  };

  const handleSave = (event) => {
    // 권세현 창고 저장
    let msg = '';
    if((inputs.warehouse_name).trim() === ''){
      msg = '창고명은 필수 입력 값 입니다.'
    }else if(inputs.workplace_id === 0){
      msg = '사업장은 필수 선택 입니다.'
    }else if(inputs.warehouse_width !== '' && Number(inputs.warehouse_width) < 0){
      msg = '창고규격(가로)는 0보다 작을 수 없습니다.'
    }else if(inputs.warehouse_depth !== '' && Number(inputs.warehouse_depth) < 0){
      msg = '창고규격(세로)는 0보다 작을 수 없습니다.'
    }else if(inputs.warehouse_height !== '' && Number(inputs.warehouse_height) < 0){
      msg = '창고규격(높이)는 0보다 작을 수 없습니다.'
    }
    
    if(updateSectionRows.length > 0 && msg === ''){
      for(let i = 0; i < sectionRows.length; i++) {
        const currElem = (sectionRows[i].section_name).trim();
        for(let j = i+1; j < sectionRows.length; j++) {
          if(currElem === (sectionRows[j].section_name).trim() && currElem !== '') {
            msg = '중복된 구역명이 존재합니다.<br/>[중복된 구역명 : '+currElem+']';
            break;
          }
        }

        if(msg !== '')  {
          break;
        }
      }

      for(let i = 0; i < updateSectionRows.length; i++) {
        const currElem = (updateSectionRows[i].section_name).trim();
        if(currElem === '') {
          msg = '입력되지 않은 구역명이 존재합니다.';
          break;
        }
      }
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">창고 수정 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);

      axios.post("/api/p/Warehouse/Update", {inputs,updateSectionRows} ,
          { withCredentials: true })
        .then(function (response) {
          if(response.status === 200){
            Swal.fire({
              title: '창고 수정 완료',
              text: '정상적으로 창고가 수정 되었습니다.',
              confirmButtonText: '확인',
              timer:5000,
              timerProgressBar: true
            }).then((result) => {
              handleView();
            });
        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
          appStore.capture();
      })
      .finally(() => {
        appStore.setLoading(false); 
      });
    }
  };

  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={tabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="창고 정보" value="1" />
                <Tab label="창고 구역" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1" ref={tabPanelRef}>
              <table className="ModalTABLE">
                <tbody>
                  <tr>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">창고명<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <input type="text" placeholder="창고" value={inputs.warehouse_name} name="warehouse_name" onChange={(e) => onChange(e) } autoComplete="off" />
                        </div>
                      </div>
                    </td>
                    <td className="ModalTD">
                      <div className="modal_filed">
                        <div className="modal_filed_title">사업장<span className="essential">*</span></div>
                        <div className="modal_filed_input">
                          <Select className="modal_filed_input_select" placeholder="사업장" value={workplaceModalOption.filter(function (option) { return option.value === inputs.workplace_id;  })} onChange={(e) => onSelectChange('workplace_id',e.value)} options={workplaceModalOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                        <div className="modal_filed_title">창고규격</div>
                        <div className="modal_filed_input" style={ { display: 'flex', width: '768px' } }>
                        <div className="modal_filed_title" style={ { width: '100px', paddingLeft: '15px'} }>가로</div>
                          <input type="number" placeholder="가로" value={inputs.warehouse_width} name="warehouse_width" onChange={(e) => onChange(e) } style={{ float: 'left', width: '130px', marginRight: '15px' }} autoComplete="off" />
                        <div className="modal_filed_title" style={ { width: '100px', paddingLeft: '15px'} }>세로</div>
                          <input type="number" placeholder="세로" value={inputs.warehouse_depth} name="warehouse_depth" onChange={(e) => onChange(e) } style={{ float: 'left', width: '130px', marginRight: '15px' }} autoComplete="off" />
                        <div className="modal_filed_title" style={ { width: '100px', paddingLeft: '15px'} }>높이</div>
                          <input type="number" placeholder="높이" value={inputs.warehouse_height} name="warehouse_height" onChange={(e) => onChange(e) } style={{width: '130px'}} autoComplete="off" />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="ModalTD" colSpan={2}>
                      <div className="modal_filed">
                      <div className="modal_filed_title">비고</div>
                        <div className="modal_filed_input">
                          <textarea placeholder="비고" name="warehouse_memo" value={inputs.warehouse_memo} onChange={(e) => onChange(e) } style={{width: '768px', height: '150px', marginTop:'10px', border:'2px lightgrey solid', borderRadius: '5px', fontSize:'17px', fontFamily:'none', resize:'none'}} autoComplete="off">
                          </textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={sectionRows}
                  columns={sectionColumns}
                  columnVisibilityModel={sectionColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processSectionRowUpdate}
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18,  
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                    {updateFlag &&
                    <div className="modal_button">
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 18, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        수정
                      </Button>
                    </div> }
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </PCModal>
  );
}

export default WarehouseUpdateModal;